import { render, staticRenderFns } from "./faqAccommodation.vue?vue&type=template&id=b3407904&scoped=true"
import script from "./faqAccommodation.vue?vue&type=script&lang=js"
export * from "./faqAccommodation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3407904",
  null
  
)

export default component.exports